/**
 * @generated SignedSource<<140856ef753b18ac7765c4863574a443>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "model"
        }
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "model",
                    "variableName": "model"
                }
            ],
            "concreteType": "DeleteScheduleShiftAttachmentPayload",
            "kind": "LinkedField",
            "name": "deleteScheduleShiftAttachment",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "EdgeOfScheduleShiftAttachment",
                    "kind": "LinkedField",
                    "name": "scheduleShiftAttachmentEdge",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "ScheduleShiftAttachment",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "id",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "useScheduleShiftAttachments_deleteFileMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "useScheduleShiftAttachments_deleteFileMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "e09ef63af508765e7aa39e4e3f29877c",
            "id": null,
            "metadata": {},
            "name": "useScheduleShiftAttachments_deleteFileMutation",
            "operationKind": "mutation",
            "text": "mutation useScheduleShiftAttachments_deleteFileMutation(\n  $model: DeleteScheduleShiftAttachmentRequestInput!\n) {\n  deleteScheduleShiftAttachment(model: $model) {\n    scheduleShiftAttachmentEdge {\n      node {\n        id\n      }\n    }\n  }\n}\n"
        }
    };
})();
node.hash = "61ea14efaea52ae19d27f99ca64ab75e";
export default node;
